module.exports = __webpack_public_path__ + "img/mailfence.53cc9ca9.svg";